import Image from "next/image";
import river from "public/images/RiverOfFlame.png";

import { H3, InternalLink, useBreakpoints } from "@sorcery/ui";

import type { CollectionCardDTOType } from "~/types/collection";
import { collectionPath } from "~/utils/paths";
import { CollectionListTeaserCard } from "./CollectionListTeaserCard";

export const CollectionListTeaser = ({
  cards,
}: {
  cards: CollectionCardDTOType[];
}) => {
  const { isLg } = useBreakpoints();
  return (
    <div
      className="group relative cursor-pointer rounded-xl border border-transparent transition-all duration-700 animate-in fade-in
    hover:border-white hover:shadow-[0_0_14px_rgba(255,255,255,0.75)]"
    >
      <InternalLink href={collectionPath}>
        <div className={"absolute left-0 top-0 h-[350px] w-full rounded-xl gradient-mask-b-90"}>
          {/* BG image */}
          <div className="absolute right-0 top-0 h-full w-full duration-700 animate-in fade-in">
            <Image
              priority={true}
              src={river}
              fill={true}
              className={
                "object-cover object-[center_40%] brightness-90 gradient-mask-r-80 sm:object-[center_50%] sm:brightness-110 md:object-[center_40%] lg:object-[center_30%] xl:object-[center_18%]"
              }
              alt={""}
            />
          </div>

          {/* gradient */}
          <div
            className="absolute h-[350px] w-full gradient-mask-r-80"
            style={{
              backgroundImage: `
      linear-gradient(240deg, rgba(2, 2, 2, 0.1) 0%, rgba(2, 2, 2, 0.1) 40%), 
      linear-gradient(0deg, rgba(2, 2, 2, 0.8) 0%, rgba(2, 2, 2, 0.1) 40%), 
      linear-gradient(120deg, rgba(2, 2, 2, 0.8) 0%, rgba(2, 2, 2, 0.1) 60%), 
      linear-gradient(180deg, rgba(2, 2, 2, 0.5) 0%, rgba(2, 2, 2, 0.1) 30%)`,
            }}
          />
        </div>
        {/* gradient 2 */}
        <div className="absolute h-[350px] w-full gradient-mask-b-80 [background-image:radial-gradient(circle,_rgba(0,0,0,0.5)_50%,_rgba(0,0,0,0)_100%)]" />

        {/* Content card */}
        <div className="p-4">
          <div className="h-[300px] gradient-mask-b-90">
            <H3 className="!mb-2 px-8 pt-4 text-center !font-extrabold lg:text-left">
              Go to Collection
            </H3>
            <div className="h-full opacity-90 transition-all duration-300 gradient-mask-l-90 group-hover:scale-[1.005] group-hover:opacity-40">
              <div className="min-h-[50%] gradient-mask-t-90">
                <div className="min-h-[50%] gradient-mask-r-90">
                  <div className="min-h-[50%] gradient-mask-b-90">
                    {cards.slice(0, isLg ? 20 : 10).map((c) => (
                      <CollectionListTeaserCard card={c} key={c.card.id} />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </InternalLink>
    </div>
  );
};
